import React, { useMemo } from 'react'
import { Box, Grid, Stack, Typography } from '@mui/material';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import more from "highcharts/highcharts-more";
import * as HighchartsDrillDownModule from "highcharts/modules/drilldown";
import TitleBar from "components/TitleBar";
import { Error, Loader } from './common';

if (typeof more === "function") {
    more(Highcharts);
}

const drilldownModule = HighchartsDrillDownModule.default;
if (typeof drilldownModule === "function") {
    drilldownModule(Highcharts);
}

const items = [
    { label: "Open", count: 1, color: "#2FA8FF", key: "openNCRs" },
    {
        label: "Closed",
        count: 0,
        color: "#6EDC8C",
        key: "closedNCRs"
    }
];



const getCenterTemplate = (val) => `
  <div style="
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    pointer-events: none;
  ">
    <span style="
      font-size: 24px; 
      font-weight: 700; 
      font-family: 'Outfit', sans-serif; 
      color: #000000;
      line-height: 1;
    ">
      ${val}
    </span>
  </div>
`;


const IncidentStatus = ({ kpis, isLoading, isError }) => {
    //const updatedItems = items?.map(item => ({ ...item, count: Number(kpis?.[item.key] ?? 0) })) || []
    const updatedItems = items?.map(item => ({ ...item })) || []
    const totalCount = useMemo(() => updatedItems.reduce((acc, curr) => acc + curr?.count, 0), [updatedItems]);

    const options = useMemo(() => {
        return {
            chart: {
                type: "pie",
                height: 250,
                backgroundColor: "transparent",
                events: {
                    // drilldown: function (e) {
                    //     const subTotal = e.seriesOptions.data.reduce(
                    //         (acc, p) => acc + (p.y || 0),
                    //         0
                    //     );

                    //     this.setTitle({
                    //         text: getCenterTemplate(subTotal),
                    //     });
                    // },
                    // drillup: function () {
                    //     this.setTitle({
                    //         text: getCenterTemplate(totalCount),
                    //     });
                    // },
                    render: function () {
                        const chart = this;

                        if (chart.customCenterText) {
                            chart.customCenterText.destroy();
                            chart.customSubText.destroy();
                        }

                        const centerX = chart.plotLeft + chart.plotWidth / 2;
                        const centerY = chart.plotTop + chart.plotHeight / 2;

                        chart.customCenterText = chart.renderer
                            .text(`${totalCount}`, centerX, centerY - 5)
                            .css({
                                fontSize: "24px",
                                fontWeight: "bold",
                                fontFamily: "Outfit, sans-serif",
                                color: "#000",
                                textAnchor: "middle",
                            })
                            .attr({ align: "center" })
                            .add();

                        chart.customSubText = chart.renderer
                            .text("Total Incidents", centerX, centerY + 18)
                            .css({
                                fontSize: "14px",
                                fontFamily: "Outfit, sans-serif",
                                color: "#737791",
                                textAnchor: "middle",
                            })
                            .attr({ align: "center" })
                            .add();
                    },
                },
                margin: 0,
            },

            // title: {
            //     text: getCenterTemplate(totalCount),
            //     align: "center",
            //     verticalAlign: "middle",
            //     useHTML: true,
            //     y: 25,
            // },
            title: {
                text: ""
            },

            tooltip: {
                headerFormat: "",
                pointFormat:
                    '<span style="color:{point.color}">\u25CF</span> {point.name}: <b>{point.y}</b><br/>',
            },

            plotOptions: {
                pie: {
                    innerSize: "75%",
                    size: "100%",
                    borderWidth: 0,
                    borderRadius: 0,
                    borderColor: "#fff",
                    dataLabels: {
                        enabled: false,
                    },
                },
            },

            series: [
                {
                    name: "Status",
                    data: updatedItems?.map((item) => ({
                        y: parseInt(item.count, 10),
                        name: item.label,
                        color: item.color,
                        drilldown: item.isDrill ? item.id : null,
                    })),
                },
            ],

            // drilldown: {
            //     series: drilldownItems,
            // },

            credits: {
                enabled: false,
            },

            legend: {
                enabled: false,
            },
        };
    }, [totalCount]);
    return (
        <Box sx={{ boxSizing: "border-box" }}>
            <TitleBar title={"Incident Status"} description={"Incident Status"} />

            {isLoading && <Loader isLoading={isLoading} />}

            {isError && <Error isError={isError} />}

            {!isLoading && !isError && <Grid
                container
                sx={{ alignItems: "center", justifyContent: "space-between", px: 2 }}
                spacing={1}
            >
                <Grid size={{ md: 6 }}>
                    <Stack
                        spacing={2.4}
                        sx={{
                            pt: 1.5,
                            pl: 1.5,
                            pb: 1.5,
                            maxHeight: "310px",
                            minHeight: "310px",
                            overflowY: "auto",
                            justifyContent: "center",
                        }}
                    >
                        {updatedItems?.map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    border: "1px solid #EAEAEA",
                                    borderRadius: "4px",
                                    padding: "8px 10px",
                                    backgroundColor: "#fff",
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                    <Box
                                        sx={{
                                            width: 12,
                                            height: 12,
                                            borderRadius: "50%",
                                            backgroundColor: item?.color,
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            color: "#010814",
                                            fontFamily: "Outfit, sans-serif",
                                            lineHeight: "18px",
                                            verticalAlign: "middle",
                                        }}
                                    >
                                        {item?.label}
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        minWidth: 40,
                                        height: 18,
                                        borderRadius: "5px",
                                        backgroundColor: "#E7E7EB",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: "#433F5E",
                                        fontFamily: "Outfit, sans-serif",
                                    }}
                                >
                                    {item.count === 0 ? 0 : String(item?.count).padStart(2, "0")}
                                </Box>
                            </Box>
                        ))}
                    </Stack>
                </Grid>
                <Grid size={{ md: 5.5 }}>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}

                    />
                </Grid>
            </Grid>}
        </Box>
    )
}

export default IncidentStatus
